/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { uiSchema } from '../schema/pg-config.schema';

export const getUiSchemaOption = (key: string): { unit: string } | undefined =>
  getUiSchemaOptionRecursive(uiSchema, key);

const getUiSchemaOptionRecursive = (uiSchema: any, key: string): { unit: string } | undefined => {
  return Object.keys(uiSchema)
    .map(k => {
      if (typeof uiSchema[k] !== 'object') {
        return undefined;
      } else if (k === key) {
        return uiSchema[k]['ui:options'];
      } else if (uiSchema[k]['ui:options'] === undefined) {
        return getUiSchemaOptionRecursive(uiSchema[k], key);
      } else {
        return undefined;
      }
    })
    .reduce((result, currentValue) => {
      if (currentValue) {
        result = currentValue;
      }
      return result;
    }, undefined);
};
